import React, { useMemo, useState } from "react";
import classes from "./Exceptions.module.css";

import Header from "../../Components/Header/Header";
import Sidebar from "../../Components/Sidebar/Sidebar";

import {
  AlertTriangle,
  AlertCircle,
  CheckCircle2,
  Clock3,
  Search,
  ChevronDown,
  MoreVertical,
  RefreshCw,
  Download,
  Eye,
  X,
  Info,
} from "lucide-react";

const exceptionData = [
  {
    id: 1,
    date: "27 Aug 2026",
    time: "10:30 AM",
    run: "RUN-2026-0527",
    account: "GTBank Main Account",
    accountNumber: "0123456789",
    type: "Unmatched Bank Transaction",
    description: "Bank Transaction on 27 Aug 2026 not matched in ledger",
    amount: "₦125,430.50",
    priority: "High",
    age: "2 days",
    status: "Open",
  },
  {
    id: 2,
    date: "27 Aug 2026",
    time: "09:25 AM",
    run: "RUN-2026-0547",
    account: "Access Bank Account",
    accountNumber: "0123456789",
    type: "Amount Difference",
    description: "Amount differs between bank (₦465,670.00) and ledger (₦465,200.00)",
    amount: "₦470.00",
    priority: "High",
    age: "2 days",
    status: "Open",
  },
  {
    id: 3,
    date: "27 Aug 2026",
    time: "10:30 AM",
    run: "RUN-2026-0527",
    account: "Zenith USD Account",
    accountNumber: "0123456789",
    type: "Unmatched Ledger Entry",
    description: "Ledger entry on 27 Aug 2026 not found in bank",
    amount: "12,450.00",
    priority: "Medium",
    age: "2 days",
    status: "Open",
  },
  {
    id: 4,
    date: "25 May 2026",
    time: "10:30 AM",
    run: "RUN-2026-0625",
    account: "GTBank Main Account",
    accountNumber: "0123456789",
    type: "Duplicate Entry",
    description: "Duplicate bank transaction detected",
    amount: "₦8,920.00",
    priority: "Medium",
    age: "4 days",
    status: "Open",
  },
  {
    id: 5,
    date: "27 Aug 2026",
    time: "10:30 AM",
    run: "RUN-2026-0527",
    account: "GTBank Main Account",
    accountNumber: "0123456789",
    type: "Unmatched Bank Transaction",
    description: "Bank Transaction on 27 Aug 2026 not matched in ledger",
    amount: "₦1,250,000.00",
    priority: "High",
    age: "2 days",
    status: "Open",
  },
  {
    id: 6,
    date: "27 Aug 2026",
    time: "10:30 AM",
    run: "RUN-2026-0527",
    account: "GTBank Main Account",
    accountNumber: "0123456789",
    type: "Unmatched Bank Transaction",
    description: "Bank Transaction on 27 Aug 2026 not matched in ledger",
    amount: "₦1,250,000.00",
    priority: "High",
    age: "2 days",
    status: "Open",
  },
  {
    id: 7,
    date: "27 Aug 2026",
    time: "10:30 AM",
    run: "RUN-2026-0527",
    account: "GTBank Main Account",
    accountNumber: "0123456789",
    type: "Unmatched Bank Transaction",
    description: "Bank Transaction on 27 Aug 2026 not matched in ledger",
    amount: "₦1,250,000.00",
    priority: "High",
    age: "2 days",
    status: "Open",
  },
  {
    id: 8,
    date: "27 Aug 2026",
    time: "10:30 AM",
    run: "RUN-2026-0527",
    account: "GTBank Main Account",
    accountNumber: "0123456789",
    type: "Unmatched Bank Transaction",
    description: "Bank Transaction on 27 Aug 2026 not matched in ledger",
    amount: "₦1,250,000.00",
    priority: "High",
    age: "2 days",
    status: "Open",
  },
  {
    id: 9,
    date: "27 Aug 2026",
    time: "10:30 AM",
    run: "RUN-2026-0527",
    account: "GTBank Main Account",
    accountNumber: "0123456789",
    type: "Unmatched Bank Transaction",
    description: "Bank Transaction on 27 Aug 2026 not matched in ledger",
    amount: "₦1,250,000.00",
    priority: "High",
    age: "2 days",
    status: "Open",
  },
  {
    id: 10,
    date: "27 Aug 2026",
    time: "10:30 AM",
    run: "RUN-2026-0527",
    account: "GTBank Main Account",
    accountNumber: "0123456789",
    type: "Unmatched Bank Transaction",
    description: "Bank Transaction on 27 Aug 2026 not matched in ledger",
    amount: "₦1,250,000.00",
    priority: "High",
    age: "2 days",
    status: "Open",
  },
];

function PriorityBadge({ priority }) {
  return (
    <span
      className={`${classes.priorityBadge} ${
        priority === "High"
          ? classes.highPriority
          : priority === "Medium"
          ? classes.mediumPriority
          : classes.lowPriority
      }`}
    >
      {priority}
    </span>
  );
}

function StatCard({ icon, iconClass, title, value, subtitle }) {
  return (
    <div className={classes.statCard}>
      <div className={`${classes.statIcon} ${iconClass}`}>{icon}</div>

      <div className={classes.statContent}>
        <span className={classes.statTitle}>{title}</span>
        <strong className={classes.statValue}>{value}</strong>
        <span className={classes.statSubtitle}>{subtitle}</span>
      </div>
    </div>
  );
}

function Exceptions() {
  const [search, setSearch] = useState("");
  const [runFilter, setRunFilter] = useState("All Runs");
  const [accountFilter, setAccountFilter] = useState("All Accounts");
  const [typeFilter, setTypeFilter] = useState("All Exception Types");
  const [priorityFilter, setPriorityFilter] = useState("All Priorities");
  const [selectedException, setSelectedException] = useState(exceptionData[0]);
  const [openMenu, setOpenMenu] = useState(null);
  const [page, setPage] = useState(1);

  const filteredExceptions = useMemo(() => {
    return exceptionData.filter((item) => {
      const searchValue = search.toLowerCase();

      const matchesSearch =
        item.run.toLowerCase().includes(searchValue) ||
        item.account.toLowerCase().includes(searchValue) ||
        item.type.toLowerCase().includes(searchValue) ||
        item.description.toLowerCase().includes(searchValue);

      const matchesRun =
        runFilter === "All Runs" || item.run === runFilter;

      const matchesAccount =
        accountFilter === "All Accounts" ||
        item.account === accountFilter;

      const matchesType =
        typeFilter === "All Exception Types" ||
        item.type === typeFilter;

      const matchesPriority =
        priorityFilter === "All Priorities" ||
        item.priority === priorityFilter;

      return (
        matchesSearch &&
        matchesRun &&
        matchesAccount &&
        matchesType &&
        matchesPriority
      );
    });
  }, [
    search,
    runFilter,
    accountFilter,
    typeFilter,
    priorityFilter,
  ]);

  const handleRefresh = () => {
    setSearch("");
    setRunFilter("All Runs");
    setAccountFilter("All Accounts");
    setTypeFilter("All Exception Types");
    setPriorityFilter("All Priorities");
    setPage(1);
  };

  const handleExport = () => {
    const headers = [
      "Date",
      "Run",
      "Account",
      "Exception Type",
      "Description",
      "Amount",
      "Priority",
      "Age",
      "Status",
    ];

    const rows = filteredExceptions.map((item) => [
      `${item.date} ${item.time}`,
      item.run,
      item.account,
      item.type,
      item.description,
      item.amount,
      item.priority,
      item.age,
      item.status,
    ]);

    const csvContent = [
      headers.join(","),
      ...rows.map((row) =>
        row.map((value) => `"${String(value).replace(/"/g, '""')}"`).join(",")
      ),
    ].join("\n");

    const blob = new Blob([csvContent], {
      type: "text/csv;charset=utf-8;",
    });

    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");

    link.href = url;
    link.download = "exceptions.csv";
    link.click();

    URL.revokeObjectURL(url);
  };

  return (
    <div className={classes.pageContainer}>
      {/* EXISTING SIDEBAR */}
      <Sidebar />

      <div className={classes.mainArea}>
        {/* EXISTING HEADER */}
        <Header />

        <main className={classes.content}>
          <div className={classes.pageHeader}>
            <div>
              <h1>Exceptions</h1>
              <p>Review and resolve all reconciliation exceptions</p>
            </div>
          </div>

          {/* STAT CARDS */}
          <section className={classes.statsGrid}>
            <StatCard
              icon={<AlertTriangle size={19} />}
              iconClass={classes.blueIcon}
              title="Total Exceptions"
              value="152"
              subtitle="Across all runs"
            />

            <StatCard
              icon={<AlertCircle size={19} />}
              iconClass={classes.redIcon}
              title="High Priority"
              value="45"
              subtitle="29.6% of total"
            />

            <StatCard
              icon={<AlertCircle size={19} />}
              iconClass={classes.orangeIcon}
              title="Medium Priority"
              value="78"
              subtitle="51.3% of total"
            />

            <StatCard
              icon={<AlertCircle size={19} />}
              iconClass={classes.greenIcon}
              title="Low Priority"
              value="29"
              subtitle="19.1% of total"
            />

            <StatCard
              icon={<Clock3 size={19} />}
              iconClass={classes.purpleIcon}
              title="Older Exception"
              value="15 Days"
              subtitle="Since 12 May 2026"
            />
          </section>

          {/* FILTER BAR */}
          <section className={classes.filterContainer}>
            <div className={classes.searchBox}>
              <Search size={16} />
              <input
                type="text"
                placeholder="Search exceptions..."
                value={search}
                onChange={(e) => {
                  setSearch(e.target.value);
                  setPage(1);
                }}
              />
            </div>

            <div className={classes.filterSelect}>
              <select
                value={runFilter}
                onChange={(e) => {
                  setRunFilter(e.target.value);
                  setPage(1);
                }}
              >
                <option>All Runs</option>
                <option>RUN-2026-0527</option>
                <option>RUN-2026-0547</option>
                <option>RUN-2026-0625</option>
              </select>
              <ChevronDown size={15} />
            </div>

            <div className={classes.filterSelect}>
              <select
                value={accountFilter}
                onChange={(e) => {
                  setAccountFilter(e.target.value);
                  setPage(1);
                }}
              >
                <option>All Accounts</option>
                <option>GTBank Main Account</option>
                <option>Access Bank Account</option>
                <option>Zenith USD Account</option>
              </select>
              <ChevronDown size={15} />
            </div>

            <div className={classes.filterSelect}>
              <select
                value={typeFilter}
                onChange={(e) => {
                  setTypeFilter(e.target.value);
                  setPage(1);
                }}
              >
                <option>All Exception Types</option>
                <option>Unmatched Bank Transaction</option>
                <option>Amount Difference</option>
                <option>Unmatched Ledger Entry</option>
                <option>Duplicate Entry</option>
              </select>
              <ChevronDown size={15} />
            </div>

            <div className={classes.filterSelect}>
              <select
                value={priorityFilter}
                onChange={(e) => {
                  setPriorityFilter(e.target.value);
                  setPage(1);
                }}
              >
                <option>All Priorities</option>
                <option>High</option>
                <option>Medium</option>
                <option>Low</option>
              </select>
              <ChevronDown size={15} />
            </div>

            <button
              className={classes.moreFiltersButton}
              type="button"
            >
              <span>More Filters</span>
              <ChevronDown size={14} />
            </button>

            <button
              className={classes.iconButton}
              type="button"
              onClick={handleRefresh}
              title="Reset filters"
            >
              <RefreshCw size={16} />
            </button>

            <button
              className={classes.exportButton}
              type="button"
              onClick={handleExport}
            >
              <Download size={15} />
              Export
            </button>
          </section>

          {/* TABLE */}
          <section className={classes.tableCard}>
            <div className={classes.tableWrapper}>
              <table className={classes.exceptionTable}>
                <thead>
                  <tr>
                    <th>Date</th>
                    <th>Run</th>
                    <th>Account</th>
                    <th>Exception Type</th>
                    <th>Description</th>
                    <th>Amount (₦)</th>
                    <th>Priority</th>
                    <th>Age / Status</th>
                    <th>Actions</th>
                  </tr>
                </thead>

                <tbody>
                  {filteredExceptions.map((item) => (
                    <tr
                      key={item.id}
                      className={
                        selectedException?.id === item.id
                          ? classes.selectedRow
                          : ""
                      }
                      onClick={() => setSelectedException(item)}
                    >
                      <td>
                        <div className={classes.dateCell}>
                          <strong>{item.date}</strong>
                          <span>{item.time}</span>
                        </div>
                      </td>

                      <td>
                        <span className={classes.runLink}>
                          {item.run}
                        </span>
                      </td>

                      <td>
                        <div className={classes.accountCell}>
                          <strong>{item.account}</strong>
                          <span>{item.accountNumber}</span>
                        </div>
                      </td>

                      <td>
                        <div className={classes.typeCell}>
                          <strong>
                            {item.type.split(" ").slice(0, 2).join(" ")}
                          </strong>

                          {item.type
                            .split(" ")
                            .slice(2)
                            .join(" ") && (
                            <span>
                              {item.type
                                .split(" ")
                                .slice(2)
                                .join(" ")}
                            </span>
                          )}
                        </div>
                      </td>

                      <td>
                        <div className={classes.descriptionCell}>
                          {item.description}
                        </div>
                      </td>

                      <td>
                        <span className={classes.amount}>
                          {item.amount}
                        </span>
                      </td>

                      <td>
                        <PriorityBadge priority={item.priority} />
                      </td>

                      <td>
                        <div className={classes.ageStatus}>
                          <span className={classes.age}>{item.age}</span>
                          <span className={classes.status}>
                            {item.status}
                          </span>
                        </div>
                      </td>

                      <td>
                        <div className={classes.actionWrapper}>
                          <button
                            type="button"
                            className={classes.actionButton}
                            onClick={(e) => {
                              e.stopPropagation();
                              setOpenMenu(
                                openMenu === item.id ? null : item.id
                              );
                            }}
                          >
                            <MoreVertical size={17} />
                          </button>

                          {openMenu === item.id && (
                            <div className={classes.actionMenu}>
                              <button
                                type="button"
                                onClick={() => {
                                  setSelectedException(item);
                                  setOpenMenu(null);
                                }}
                              >
                                <Eye size={14} />
                                View Details
                              </button>

                              <button
                                type="button"
                                onClick={() => setOpenMenu(null)}
                              >
                                <CheckCircle2 size={14} />
                                Resolve
                              </button>
                            </div>
                          )}
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>

              {filteredExceptions.length === 0 && (
                <div className={classes.emptyState}>
                  <Search size={30} />
                  <strong>No exceptions found</strong>
                  <span>
                    Try changing your search or filter options.
                  </span>
                </div>
              )}
            </div>

            <div className={classes.tableFooter}>
              <span>
                Showing 1 to {filteredExceptions.length} of 152 exceptions
              </span>

              <div className={classes.pagination}>
                <button
                  type="button"
                  disabled={page === 1}
                  onClick={() => setPage((prev) => Math.max(1, prev - 1))}
                >
                  ‹
                </button>

                <button
                  type="button"
                  className={page === 1 ? classes.activePage : ""}
                  onClick={() => setPage(1)}
                >
                  1
                </button>

                <button
                  type="button"
                  className={page === 2 ? classes.activePage : ""}
                  onClick={() => setPage(2)}
                >
                  2
                </button>

                <button
                  type="button"
                  className={page === 3 ? classes.activePage : ""}
                  onClick={() => setPage(3)}
                >
                  3
                </button>

                <button
                  type="button"
                  onClick={() => setPage((prev) => Math.min(16, prev + 1))}
                >
                  4
                </button>

                <span>...</span>

                <button
                  type="button"
                  onClick={() => setPage(16)}
                >
                  16
                </button>

                <button
                  type="button"
                  onClick={() => setPage((prev) => Math.min(16, prev + 1))}
                >
                  ›
                </button>

                <select
                  className={classes.pageSize}
                  defaultValue="10"
                >
                  <option value="10">10 / page</option>
                  <option value="20">20 / page</option>
                  <option value="50">50 / page</option>
                </select>
              </div>
            </div>
          </section>

          {/* EXCEPTION DETAILS */}
          {selectedException && (
            <section className={classes.detailsCard}>
              <div className={classes.exceptionDetails}>
                <div className={classes.detailsHeader}>
                  <div>
                    <h2>Exception Details</h2>
                    <PriorityBadge
                      priority={selectedException.priority}
                    />
                  </div>

                  {/* <button
                    type="button"
                    className={classes.closeDetails}
                    onClick={() => setSelectedException(null)}
                  >
                    <X size={16} />
                  </button> */}
                </div>

                <h3>Exception Information</h3>

                <div className={classes.detailRows}>
                  <div className={classes.detailRow}>
                    <span>Exception Type</span>
                    <strong>{selectedException.type}</strong>
                  </div>

                  <div className={classes.detailRow}>
                    <span>Date</span>
                    <strong>
                      {selectedException.date},{" "}
                      {selectedException.time}
                    </strong>
                  </div>

                  <div className={classes.detailRow}>
                    <span>Run</span>
                    <strong className={classes.greenText}>
                      {selectedException.run}
                    </strong>
                  </div>

                  <div className={classes.detailRow}>
                    <span>Account</span>
                    <strong>
                      {selectedException.account}
                      <small>
                        ({selectedException.accountNumber})
                      </small>
                    </strong>
                  </div>

                  <div className={classes.detailRow}>
                    <span>Amount</span>
                    <strong>{selectedException.amount}</strong>
                  </div>

                  <div className={classes.detailRow}>
                    <span>Age</span>
                    <strong>{selectedException.age}</strong>
                  </div>

                  <div className={classes.detailRow}>
                    <span>Description</span>
                    <strong>{selectedException.description}</strong>
                  </div>
                </div>
              </div>

              <div className={classes.bankTransaction}>
                <h3>Bank Transaction</h3>

                <div className={classes.transactionRows}>
                  <div>
                    <span>Run</span>
                    <strong>{selectedException.date}</strong>
                  </div>

                  <div>
                    <span>Narration</span>
                    <strong>POS Purchase - Shoprite</strong>
                  </div>

                  <div>
                    <span>Reference</span>
                    <strong>GTB/27/05/2024/001</strong>
                  </div>

                  <div>
                    <span>Amount</span>
                    <strong>{selectedException.amount}</strong>
                  </div>
                </div>

                <div className={classes.detailButtons}>
                  <button
                    type="button"
                    className={classes.viewRunButton}
                  >
                    <Eye size={14} />
                    View in Run
                  </button>

                  <button
                    type="button"
                    className={classes.resolveButton}
                  >
                    Resolve Exception
                  </button>
                </div>

                <div className={classes.possibleMatches}>
                  <h4>Possible Matches (0)</h4>

                  <div className={classes.infoBox}>
                    <Info size={15} />
                    <span>
                      No possible matches found. Try adjusting
                      matching rules or resolve manually.
                    </span>
                  </div>
                </div>
              </div>
            </section>
          )}
        </main>
      </div>
    </div>
  );
}

export default Exceptions;